(() => {
  const instances = new WeakMap();
  const compact = matchMedia('(max-width: 749px)');
  const ua = navigator.userAgent;
  const ios = /iPad|iPhone|iPod/i.test(ua) || (/Macintosh/i.test(ua) && navigator.maxTouchPoints > 1);
  const android = /Android/i.test(ua);
  if (!compact.matches && !ios && !android) return;

  function init(root) {
    if (instances.has(root)) return;
    const choices = [...root.querySelectorAll('.mj-room-choice')];
    if (!choices.length) return;
    root.dataset.mjRoomMobile = 'true';
    root.classList.add('is-mobile');
    const canvas = root.querySelector('.mj-room-canvas');
    const picker = root.querySelector('.mj-room-picker');
    const toggle = root.querySelector('.mj-room-tour-toggle');
    const position = root.querySelector('.mj-room-position');
    const hint = root.querySelector('.mj-room-hint');
    const phone = root.querySelector('.mj-room-phone');
    const status = root.querySelector('.mj-room-ar-status');
    const dialog = root.querySelector('dialog');
    const rotation = root.querySelector('.mj-room-rotate');
    const previous = root.querySelector('.mj-room-previous');
    const next = root.querySelector('.mj-room-next');
    const browse = root.querySelector('.mj-room-browse');
    const video = root.querySelector('.mj-room-intro-video');
    const qr = JSON.parse(root.querySelector('.mj-room-qr-data').textContent);
    const wallUrls = JSON.parse(root.querySelector('.mj-room-wall-data').textContent);
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    const controller = new AbortController();
    const listen = (target, type, fn, options = {}) => target.addEventListener(type, fn, { ...options, signal: controller.signal });
    const deep = new URLSearchParams(location.search).get('room');
    const intro = [...new Set([
      choices[0],
      choices.find(b => b.dataset.category === 'wall'),
      choices.find(b => b.dataset.category === 'objects'),
      ...choices
    ].filter(Boolean))].slice(0, 3);
    let active = choices.find(b => b.dataset.index === deep) || choices[0];
    let touring = !motion.matches && !deep;
    let rotating = false, visible = false, destroyed = false, started = false, loaded = false;
    let mv = null, slot = null, generation = 0, introIndex = 0, holdTimer = 0, loadTimer = 0, budgetTimer = 0, videoStarted = false;
    let animation = null, entering = false, gesture = null, remaining = 2400, dueAt = 0;
    let modelController = null;
    const poster = document.createElement('div');
    poster.className = 'mj-room-mobile-poster';
    const image = document.createElement('img');
    image.alt = '';
    const message = document.createElement('span');
    message.setAttribute('role', 'status');
    poster.append(image, message);
    canvas.append(poster);
    const pool = () => choices.filter(b => !b.hidden);
    const roomUrl = b => location.origin + '/?room=' + encodeURIComponent(b.dataset.index) + '#' + root.id;

    function mobileHelp() {
      status.hidden = false;
      status.textContent = root.dataset.arHelp;
    }

    function qrMarkup(id) {
      const q = qr[id];
      if (!q) return '';
      const bytes = atob(q.bits);
      let path = '';
      for (let j = 0; j < q.n * q.n; j++) {
        if (bytes.charCodeAt(j >> 3) & (1 << (7 - (j % 8)))) path += 'M' + (j % q.n) + ' ' + Math.floor(j / q.n) + 'h1v1h-1z';
      }
      return '<svg viewBox="0 0 ' + q.n + ' ' + q.n + '" role="img" aria-label="' + root.dataset.qrLabel + '" shape-rendering="crispEdges"><rect width="100%" height="100%" fill="white"/><path d="' + path + '" fill="#003b36"/></svg>';
    }

    function updateCopy(b) {
      active = b;
      choices.forEach(x => x.setAttribute('aria-pressed', String(x === b)));
      root.querySelector('.mj-room-name').textContent = b.dataset.title;
      root.querySelector('.mj-room-price').textContent = b.dataset.price;
      root.querySelector('.mj-room-product').href = b.dataset.url;
      root.querySelector('.mj-room-dialog-link').href = roomUrl(b);
      root.querySelector('.mj-room-qr').innerHTML = qrMarkup(b.dataset.index);
      phone.textContent = b.dataset.category === 'wall' ? root.dataset.wallLabel : root.dataset.roomLabel;
      phone.href = roomUrl(b);
      phone.removeAttribute('rel');
      phone.dataset.launch = 'viewer';
      status.hidden = true;
      const usdz = wallUrls[b.dataset.index] || b.dataset.usdz;
      const arImage = document.createElement('img');
      arImage.src = b.dataset.poster;
      arImage.alt = '';
      arImage.width = 1;
      arImage.height = 1;
      arImage.style.cssText = 'position:absolute;width:1px;height:1px;opacity:0';
      phone.append(arImage);
      if (ios && usdz) {
        phone.rel = 'ar';
        phone.href = new URL(usdz, location.origin).href;
        phone.dataset.launch = 'quick-look';
      } else if (android && b.dataset.glb) {
        const q = new URLSearchParams({file:new URL(b.dataset.glb,location.origin).href,mode:'ar_preferred',title:b.dataset.title,link:new URL(b.dataset.url,location.origin).href});
        if (b.dataset.category === 'wall') q.set('enable_vertical_placement', 'true');
        const fallback = new URL(roomUrl(b));
        fallback.searchParams.set('ar_unavailable', '1');
        phone.href = 'intent://arvr.google.com/scene-viewer/1.2?' + q + '#Intent;scheme=https;package=com.google.android.googlequicksearchbox;action=android.intent.action.VIEW;S.browser_fallback_url=' + encodeURIComponent(fallback.href) + ';end;';
        phone.dataset.launch = 'scene-viewer';
      }
      if (new URLSearchParams(location.search).has('ar_unavailable')) mobileHelp();
      syncControls();
    }

    function clearHold() {
      if (holdTimer) remaining = Math.max(0, dueAt - performance.now());
      clearTimeout(holdTimer);
      holdTimer = 0;
    }

    function cancelAnimation() {
      animation?.cancel();
      animation = null;
      entering = false;
      slot?.classList.remove('is-entering');
    }

    function stopTour(load = true) {
      if (!touring) return;
      touring = false;
      generation++;
      clearHold();
      clearTimeout(budgetTimer);
      cancelAnimation();
      if (video) { video.pause(); video.hidden = true; }
      mv?.setAttribute('camera-orbit', '25deg 75deg 120%');
      sync();
      if (load) start();
    }

    function syncControls() {
      const list = pool();
      const index = list.indexOf(active);
      position.textContent = touring ? root.dataset.introLabel + ' ' + (introIndex + 1) + ' / ' + intro.length : (index + 1) + ' / ' + list.length;
      toggle.textContent = touring ? root.dataset.skipLabel : root.dataset.replayLabel;
      toggle.setAttribute('aria-pressed', String(touring));
      rotation.textContent = rotating ? root.dataset.swipeLabel : root.dataset.rotateLabel;
      rotation.setAttribute('aria-pressed', String(rotating));
      hint.textContent = touring ? root.dataset.introHint : rotating ? root.dataset.rotateHint : root.dataset.swipeHint;
      previous.disabled = next.disabled = list.length < 2;
      root.dataset.roomMode = touring ? 'intro' : rotating ? 'rotate' : 'browse';
      if (mv) {
        mv.toggleAttribute('camera-controls', rotating);
        mv.setAttribute('touch-action', 'pan-y');
      }
    }

    function sync() {
      if (destroyed) return;
      syncControls();
      const running = touring && visible && !document.hidden;
      if (video && touring) {
        if (!running) video.pause();
        else if (video.paused && videoStarted) video.play().catch(() => stopTour());
        return;
      }
      mv?.toggleAttribute('auto-rotate', running && loaded && !motion.matches);
      if (!running) { clearHold(); return; }
      if (!loaded || entering || holdTimer) return;
      dueAt = performance.now() + remaining;
      holdTimer = setTimeout(() => {
        holdTimer = 0;
        remaining = 2400;
        if (!touring || !visible || document.hidden) return;
        if (introIndex + 1 >= intro.length) { stopTour(); return; }
        introIndex++;
        showModel(intro[introIndex], true);
      }, remaining);
    }

    function loadError() {
      clearTimeout(loadTimer);
      loaded = false;
      poster.hidden = false;
      message.textContent = root.dataset.loadError;
      stopTour();
      sync();
    }

    async function onLoad() {
      if (destroyed || loaded) return;
      loaded = true;
      clearTimeout(loadTimer);
      poster.hidden = true;
      const token = generation;
      if (touring && !motion.matches && visible) {
        entering = true;
        slot.classList.add('is-entering');
        mv.setAttribute('auto-rotate', '');
        mv.setAttribute('camera-orbit', '25deg 75deg 120%');
        animation = slot.animate([
          {transform:'translate3d(28%,85%,0) rotateZ(55deg) rotateX(60deg) scale(.78)',opacity:0},
          {transform:'translate3d(7%,12%,0) rotateZ(12deg) rotateX(15deg) scale(.96)',opacity:1,offset:.65},
          {transform:'none',opacity:1}
        ],{duration:600,easing:'cubic-bezier(.22,.65,.24,1)',fill:'both'});
        await animation.finished.catch(() => {});
        if (token !== generation || destroyed) return;
        cancelAnimation();
      }
      sync();
    }

    async function showModel(b, transition = false) {
      const token = ++generation;
      clearHold();
      clearTimeout(loadTimer);
      cancelAnimation();
      if (mv && loaded && transition && touring && visible && !motion.matches) {
        mv.removeAttribute('auto-rotate');
        entering = true;
        animation = slot.animate([
          {transform:'none',opacity:1},
          {transform:'translate3d(-70%,85%,0) rotateZ(-65deg) rotateX(45deg) scale(.72)',opacity:0}
        ],{duration:300,easing:'cubic-bezier(.4,0,.65,1)',fill:'both'});
        await animation.finished.catch(() => {});
        if (token !== generation || destroyed) return;
        cancelAnimation();
      }
      if (destroyed || token !== generation) return;
      updateCopy(b);
      image.src = b.dataset.poster;
      poster.hidden = false;
      message.textContent = root.dataset.loadingLabel;
      remaining = 2400;
      const source = b.dataset.glb;
      if (mv && mv.getAttribute('src') === source && loaded) { poster.hidden = true; onLoadSame(); return; }
      loaded = false;
      if (!mv) {
        const template = root.querySelector('template[data-index="' + b.dataset.index + '"]');
        const fragment = template?.content.cloneNode(true);
        mv = fragment?.querySelector('model-viewer');
        if (!mv) { loadError(); return; }
        slot = document.createElement('div');
        slot.className = 'mj-room-slot';
        slot.append(fragment);
        modelController = new AbortController();
        mv.addEventListener('load', onLoad, {signal:modelController.signal});
        mv.addEventListener('error', loadError, {signal:modelController.signal});
        mv.addEventListener('camera-change', event => { if (event.detail?.source === 'user-interaction') stopTour(); }, {signal:modelController.signal});
      }
      mv.removeAttribute('auto-rotate');
      mv.toggleAttribute('camera-controls', rotating);
      mv.setAttribute('loading', 'eager');
      mv.setAttribute('reveal', 'auto');
      mv.setAttribute('poster', b.dataset.poster);
      mv.setAttribute('alt', b.dataset.fullTitle);
      mv.setAttribute('auto-rotate-delay', '0');
      mv.setAttribute('rotation-per-second', '120deg');
      mv.setAttribute('camera-orbit', touring ? '25deg 20deg 120%' : '25deg 75deg 120%');
      mv.setAttribute('camera-target', 'auto auto auto');
      mv.setAttribute('interpolation-decay', '100');
      mv.setAttribute('disable-pan', '');
      mv.setAttribute('disable-tap', '');
      mv.setAttribute('touch-action', 'pan-y');
      mv.setAttribute('ar', '');
      mv.setAttribute('ar-placement', b.dataset.category === 'wall' ? 'wall' : 'floor');
      mv.setAttribute('ar-modes', 'webxr scene-viewer quick-look');
      mv.setAttribute('shadow-intensity', b.dataset.category === 'wall' ? '0' : '.6');
      const usdz = wallUrls[b.dataset.index] || b.dataset.usdz;
      if (usdz) mv.setAttribute('ios-src', usdz); else mv.removeAttribute('ios-src');
      mv.setAttribute('src', source);
      if (!slot.isConnected) canvas.prepend(slot);
      loadTimer = setTimeout(loadError, 12000);
      sync();
    }

    function onLoadSame() { mv.setAttribute('camera-orbit', '25deg 75deg 120%'); sync(); }

    function start() {
      if (touring && video && !destroyed) {
        if (videoStarted) return;
        videoStarted = true;
        video.hidden = false;
        poster.hidden = true;
        video.currentTime = 0;
        video.play().catch(() => stopTour());
        budgetTimer = setTimeout(stopTour, 20000);
        return;
      }
      if (started || destroyed) return;
      started = true;
      showModel(active);
      if (touring) budgetTimer = setTimeout(stopTour, 20000);
      if (window.Shopify?.loadFeatures) window.Shopify.loadFeatures([{name:'model-viewer-ui',version:'1.0'}]);
    }

    function choose(b) {
      stopTour(false);
      rotating = false;
      if (!started) active = b;
      start();
      if (active !== b) showModel(b);
      else sync();
    }

    function step(direction) {
      const list = pool();
      if (list.length < 2) return;
      const index = list.indexOf(active);
      choose(list[(index + direction + list.length) % list.length]);
      const selected = active.getBoundingClientRect();
      const bounds = picker.getBoundingClientRect();
      if (!picker.classList.contains('is-expanded') && (selected.left < bounds.left || selected.right > bounds.right)) {
        picker.scrollTo({left:picker.scrollLeft + selected.left - bounds.left,behavior:motion.matches?'auto':'smooth'});
      }
    }

    listen(toggle, 'click', () => {
      if (touring) { stopTour(); return; }
      root.querySelector('[data-filter="all"]').click();
      rotating = false;
      touring = !motion.matches;
      introIndex = 0;
      clearTimeout(budgetTimer);
      clearTimeout(loadTimer);
      cancelAnimation();
      modelController?.abort();
      modelController = null;
      slot?.remove();
      slot = null;
      mv = null;
      loaded = false;
      started = false;
      videoStarted = false;
      active = intro[0];
      updateCopy(active);
      start();
      sync();
    });
    if (video) {
      listen(video, 'ended', () => {
        if (!touring) return;
        stopTour(false);
        active = intro[intro.length - 1];
        updateCopy(active);
        start();
      });
      listen(video, 'error', () => { if (touring) stopTour(); });
      listen(video, 'timeupdate', () => {
        if (!touring || !video.duration) return;
        introIndex = Math.min(intro.length - 1, Math.floor(video.currentTime / video.duration * intro.length));
        syncControls();
      });
    }
    listen(rotation, 'click', () => { stopTour(); rotating = !rotating; start(); sync(); });
    listen(previous, 'click', () => step(-1));
    listen(next, 'click', () => step(1));
    listen(canvas, 'pointerdown', event => {
      if (!event.isPrimary) return;
      stopTour();
      if (rotating) return;
      gesture = {x:event.clientX,y:event.clientY,id:event.pointerId};
      canvas.setPointerCapture(event.pointerId);
    });
    listen(canvas, 'pointerup', event => {
      if (!gesture || gesture.id !== event.pointerId) return;
      const dx = event.clientX - gesture.x, dy = event.clientY - gesture.y;
      gesture = null;
      if (canvas.hasPointerCapture(event.pointerId)) canvas.releasePointerCapture(event.pointerId);
      if (Math.abs(dx) >= 45 && Math.abs(dx) > Math.abs(dy) * 1.35) step(dx < 0 ? 1 : -1);
    });
    listen(canvas, 'pointercancel', () => { gesture = null; });
    listen(canvas, 'lostpointercapture', () => { gesture = null; });
    listen(canvas, 'keydown', event => {
      if (rotating) return;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); step(event.key === 'ArrowLeft' ? -1 : 1); }
    });
    choices.forEach(b => listen(b, 'click', () => choose(b)));
    listen(picker, 'pointerdown', stopTour, {passive:true});
    root.querySelectorAll('[data-filter]').forEach(b => listen(b, 'click', () => {
      stopTour();
      root.querySelectorAll('[data-filter]').forEach(x => x.setAttribute('aria-pressed', String(x === b)));
      choices.forEach(x => { x.hidden = b.dataset.filter !== 'all' && x.dataset.category !== b.dataset.filter; });
      root.querySelector('.mj-room-count').textContent = pool().length;
      picker.scrollLeft = 0;
      if (active.hidden && pool().length) choose(pool()[0]); else syncControls();
    }));
    listen(browse, 'click', () => {
      stopTour();
      const expanded = picker.classList.toggle('is-expanded');
      browse.setAttribute('aria-expanded', String(expanded));
      browse.textContent = expanded ? root.dataset.collapseLabel : root.dataset.browseLabel;
    });
    listen(root.querySelector('.mj-room-product'), 'click', stopTour);
    listen(phone, 'click', async event => {
      stopTour();
      start();
      if (phone.dataset.launch === 'quick-look' || phone.dataset.launch === 'scene-viewer') return;
      event.preventDefault();
      if (mv?.canActivateAR) {
        try { await mv.activateAR(); } catch { if (ios || android) mobileHelp(); else dialog.showModal(); }
      } else if (ios || android) mobileHelp(); else dialog.showModal();
    });
    listen(root.querySelector('.mj-room-close'), 'click', () => dialog.close());
    listen(dialog, 'click', event => { if (event.target === dialog) dialog.close(); });
    listen(document, 'visibilitychange', sync);
    listen(motion, 'change', () => { if (motion.matches) stopTour(); });
    const observer = new IntersectionObserver(entries => {
      visible = entries.some(entry => entry.isIntersecting);
      if (visible) start();
      sync();
    },{threshold:.1});
    observer.observe(canvas);
    const copy = root.querySelector('.mj-room-copy');
    const stage = root.querySelector('.mj-room-stage');
    [root.querySelector('.mj-room-picker-head'),root.querySelector('.mj-room-filters'),picker].forEach(element => stage.insertBefore(element,copy));
    canvas.tabIndex = 0;
    root.querySelector('.mj-room-count').textContent = choices.length;
    updateCopy(active);
    if (deep) start();
    instances.set(root,{destroy() {
      destroyed = true;
      generation++;
      clearHold();
      clearTimeout(loadTimer);
      clearTimeout(budgetTimer);
      cancelAnimation();
      video?.pause();
      controller.abort();
      modelController?.abort();
      observer.disconnect();
      slot?.remove();
      poster.remove();
      instances.delete(root);
    }});
  }

  const boot = scope => scope.querySelectorAll('.mj-room').forEach(init);
  boot(document);
  document.addEventListener('shopify:section:load', event => boot(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('.mj-room').forEach(root => instances.get(root)?.destroy()));
})();
